import React from 'react'

import { withContext, WithContextProps } from 'admin/components/common/withContext'

/**
 * Text helper component to output datetime-formatted text
 */
const DateTime: React.FunctionComponent<DateTimeProps & WithContextProps> = (
  { children, format, wrap, locale, ...otherProps },
) => {
  const formattedDateTime = locale.formatDatetime(children, format)
  return React.createElement(wrap, otherProps, formattedDateTime)
}

DateTime.defaultProps = {
  wrap: 'span',
}

type DateTimeProps = {
  children?: React.ReactText,
  format?: string,
  wrap?: string,
}

export default withContext(DateTime)
